import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    attrs: {
      "title": "校长办公会议题审批填表",
      "size": "small",
      "bordered": false
    }
  }), _c('a-button', {
    staticStyle: {
      "position": "absolute",
      "right": "15px",
      "top": "10px"
    },
    on: {
      "click": _vm.backPage
    }
  }, [_vm._v(" 返回 ")]), _c('a-row', {
    attrs: {
      "gutter": 2
    }
  }, [_c('a-col', {
    attrs: {
      "span": 7
    }
  }, [_c('a-card', {
    staticClass: "body-content",
    attrs: {
      "bordered": false
    }
  }, [_c('a-form-model', {
    ref: "addForm",
    attrs: {
      "model": _vm.formObject,
      "rules": _vm.rules,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "hideRequiredMark": true
    }
  }, [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "议题名称",
      "prop": "title"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入议题名称",
      "max-length": 201
    },
    model: {
      value: _vm.formObject.title,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "title", $$v);
      },
      expression: "formObject.title"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "汇报人",
      "prop": "reportPerson"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请填写汇报人",
      "max-length": 201,
      "disabled": ""
    },
    model: {
      value: _vm.formObject.reportPerson,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "reportPerson", $$v);
      },
      expression: "formObject.reportPerson"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "汇报部门",
      "prop": "organPostId"
    }
  }, [_c('a-cascader', {
    style: {
      width: '100%',
      textAlign: 'left'
    },
    attrs: {
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位",
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.formObject.department,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "department", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formObject.department"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "汇报时间",
      "prop": "time"
    }
  }, [_c('a-date-picker', {
    attrs: {
      "show-time": ""
    },
    on: {
      "change": _vm.onChange,
      "ok": _vm.onOk
    },
    model: {
      value: _vm.formObject.time,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "time", $$v);
      },
      expression: "formObject.time"
    }
  }, [_c('template', {
    slot: "renderExtraFooter"
  }, [_vm._v("extra footer")])], 2)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "color": "#000",
      "margin-bottom": "5px"
    }
  }, [_vm._v(" 提请审议主要事项: ")]), _c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "rows": 4,
      "placeholder": "请填写主要事项",
      "max-length": 120
    },
    model: {
      value: _vm.formObject.mainItems,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "mainItems", $$v);
      },
      expression: "formObject.mainItems"
    }
  })], 1), _c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "color": "#000",
      "margin": "5px 0"
    }
  }, [_vm._v(" 需列席的部门人员: ")]), _c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "rows": 4,
      "placeholder": "请输入需列席的部门人员",
      "max-length": 120
    },
    model: {
      value: _vm.formObject.mainItems,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "mainItems", $$v);
      },
      expression: "formObject.mainItems"
    }
  })], 1), _c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "color": "#000",
      "margin": "5px 0"
    }
  }, [_vm._v(" 上会资料提交清单: ")]), _c('div', {
    staticClass: "listing-wapper"
  }, [_c('div', {
    staticClass: "listing-menu"
  }, [_c('div', [_vm._v("封面")]), _c('div', [_c('a-radio-group', {
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("有")]), _c('a-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("无")])], 1)], 1)]), _c('div', {
    staticClass: "listing-menu"
  }, [_c('div', [_vm._v("议题审批表/紧急上会议题审批表")]), _c('div', [_c('a-radio-group', {
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("有")]), _c('a-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("无")])], 1)], 1)]), _c('div', {
    staticClass: "listing-menu"
  }, [_c('div', [_vm._v("议案正文")]), _c('div', [_c('a-radio-group', {
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("有")]), _c('a-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("无")])], 1)], 1)]), _c('div', {
    staticClass: "listing-menu-other"
  }, [_c('div', {
    staticClass: "listing-menu1"
  }, [_c('div', [_vm._v("补档文件")]), _c('div', [_c('a-radio-group', {
    on: {
      "change": _vm.onAddFile
    },
    model: {
      value: _vm.addFile,
      callback: function callback($$v) {
        _vm.addFile = $$v;
      },
      expression: "addFile"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("有")]), _c('a-radio', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("无")])], 1)], 1)]), _vm.addFile == 1 ? _c('div', {
    staticClass: "upload-class"
  }, [_c('a-upload-dragger', {
    attrs: {
      "name": "file",
      "multiple": true,
      "action": "https://www.mocky.io/v2/5cc8019d300000980a055e76"
    },
    on: {
      "change": _vm.handleChange
    }
  }, [_c('p', {
    staticClass: "ant-upload-drag-icon"
  }, [_c('a-icon', {
    attrs: {
      "type": "inbox"
    }
  })], 1), _c('p', {
    staticClass: "ant-upload-text"
  }, [_vm._v("单击此区域选择文件上传")]), _c('p', {
    staticClass: "ant-upload-hint"
  }, [_vm._v(" 允许多个上传。(支持doc、docx、jpge、jpg、pdf格式上传，最大上传500MB) ")])])], 1) : _vm._e()]), _c('div', {
    staticClass: "listing-menu-other"
  }, [_c('div', {
    staticClass: "listing-menu1"
  }, [_c('div', [_vm._v("附件资料")]), _c('div', [_c('a-radio-group', {
    on: {
      "change": _vm.onAccessory
    },
    model: {
      value: _vm.accessory,
      callback: function callback($$v) {
        _vm.accessory = $$v;
      },
      expression: "accessory"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("有")]), _c('a-radio', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("无")])], 1)], 1)]), _vm.accessory == 1 ? _c('div', {
    staticClass: "upload-class"
  }, [_c('a-upload-dragger', {
    attrs: {
      "name": "file",
      "multiple": true,
      "action": "https://www.mocky.io/v2/5cc8019d300000980a055e76"
    },
    on: {
      "change": _vm.handleChange
    }
  }, [_c('p', {
    staticClass: "ant-upload-drag-icon"
  }, [_c('a-icon', {
    attrs: {
      "type": "inbox"
    }
  })], 1), _c('p', {
    staticClass: "ant-upload-text"
  }, [_vm._v("单击此区域选择文件上传")]), _c('p', {
    staticClass: "ant-upload-hint"
  }, [_vm._v(" 允许多个上传。(支持doc、docx、jpge、jpg、pdf格式上传，最大上传500MB) ")])])], 1) : _vm._e()]), _c('div', {
    staticClass: "listing-menu-other"
  }, [_c('div', {
    staticClass: "listing-menu1"
  }, [_c('div', [_vm._v("法律意见书")]), _c('div', [_c('a-radio-group', {
    on: {
      "change": _vm.onLegalOpinion
    },
    model: {
      value: _vm.legalOpinion,
      callback: function callback($$v) {
        _vm.legalOpinion = $$v;
      },
      expression: "legalOpinion"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("有")]), _c('a-radio', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("无")])], 1)], 1)]), _vm.legalOpinion == 1 ? _c('div', {
    staticClass: "upload-class"
  }, [_c('a-upload-dragger', {
    attrs: {
      "name": "file",
      "multiple": true,
      "action": "https://www.mocky.io/v2/5cc8019d300000980a055e76"
    },
    on: {
      "change": _vm.handleChange
    }
  }, [_c('p', {
    staticClass: "ant-upload-drag-icon"
  }, [_c('a-icon', {
    attrs: {
      "type": "inbox"
    }
  })], 1), _c('p', {
    staticClass: "ant-upload-text"
  }, [_vm._v("单击此区域选择文件上传")]), _c('p', {
    staticClass: "ant-upload-hint"
  }, [_vm._v(" 允许多个上传。(支持doc、docx、jpge、jpg、pdf格式上传，最大上传500MB) ")])])], 1) : _vm._e()]), _c('div', {
    staticClass: "listing-menu-other"
  }, [_c('div', {
    staticClass: "listing-menu1"
  }, [_c('div', [_vm._v("风控法务部审查意见书")]), _c('div', [_c('a-radio-group', {
    on: {
      "change": _vm.onJusticeOpinion
    },
    model: {
      value: _vm.justiceOpinion,
      callback: function callback($$v) {
        _vm.justiceOpinion = $$v;
      },
      expression: "justiceOpinion"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("有")]), _c('a-radio', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("无")])], 1)], 1)]), _vm.justiceOpinion == 1 ? _c('div', {
    staticClass: "upload-class"
  }, [_c('a-upload-dragger', {
    attrs: {
      "name": "file",
      "multiple": true,
      "action": "https://www.mocky.io/v2/5cc8019d300000980a055e76"
    },
    on: {
      "change": _vm.handleChange
    }
  }, [_c('p', {
    staticClass: "ant-upload-drag-icon"
  }, [_c('a-icon', {
    attrs: {
      "type": "inbox"
    }
  })], 1), _c('p', {
    staticClass: "ant-upload-text"
  }, [_vm._v("单击此区域选择文件上传")]), _c('p', {
    staticClass: "ant-upload-hint"
  }, [_vm._v(" 允许多个上传。(支持doc、docx、jpge、jpg、pdf格式上传，最大上传500MB) ")])])], 1) : _vm._e()]), _c('div', {
    staticClass: "listing-menu-other"
  }, [_c('div', {
    staticClass: "listing-menu1"
  }, [_c('div', [_vm._v("相关部门审查意见表")]), _c('div', [_c('a-radio-group', {
    on: {
      "change": _vm.onDepartmentOpinion
    },
    model: {
      value: _vm.departmentOpinion,
      callback: function callback($$v) {
        _vm.departmentOpinion = $$v;
      },
      expression: "departmentOpinion"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("有")]), _c('a-radio', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("无")])], 1)], 1)]), _vm.departmentOpinion == 1 ? _c('div', {
    staticClass: "upload-class"
  }, [_c('a-upload-dragger', {
    attrs: {
      "name": "file",
      "multiple": true,
      "action": "https://www.mocky.io/v2/5cc8019d300000980a055e76"
    },
    on: {
      "change": _vm.handleChange
    }
  }, [_c('p', {
    staticClass: "ant-upload-drag-icon"
  }, [_c('a-icon', {
    attrs: {
      "type": "inbox"
    }
  })], 1), _c('p', {
    staticClass: "ant-upload-text"
  }, [_vm._v("单击此区域选择文件上传")]), _c('p', {
    staticClass: "ant-upload-hint"
  }, [_vm._v(" 允许多个上传。(支持doc、docx、jpge、jpg、pdf格式上传，最大上传500MB) ")])])], 1) : _vm._e()]), _c('div', {
    staticClass: "listing-menu-other"
  }, [_c('div', {
    staticClass: "listing-menu1"
  }, [_c('div', [_vm._v("其他意见")]), _c('div', [_c('a-radio-group', {
    on: {
      "change": _vm.onDepartmentOpinion
    },
    model: {
      value: _vm.departmentOpinion,
      callback: function callback($$v) {
        _vm.departmentOpinion = $$v;
      },
      expression: "departmentOpinion"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("有")]), _c('a-radio', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("无")])], 1)], 1)]), _vm.departmentOpinion == 1 ? _c('div', {
    staticClass: "upload-class"
  }, [_c('a-upload-dragger', {
    attrs: {
      "name": "file",
      "multiple": true,
      "action": "https://www.mocky.io/v2/5cc8019d300000980a055e76"
    },
    on: {
      "change": _vm.handleChange
    }
  }, [_c('p', {
    staticClass: "ant-upload-drag-icon"
  }, [_c('a-icon', {
    attrs: {
      "type": "inbox"
    }
  })], 1), _c('p', {
    staticClass: "ant-upload-text"
  }, [_vm._v("单击此区域选择文件上传")]), _c('p', {
    staticClass: "ant-upload-hint"
  }, [_vm._v(" 允许多个上传。(支持doc、docx、jpge、jpg、pdf格式上传，最大上传500MB) ")])])], 1) : _vm._e()]), _c('div', {
    staticClass: "listing-menu"
  }, [_c('div', [_vm._v("材料真实性承诺书")]), _c('div', [_c('a-radio-group', {
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("有")]), _c('a-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("无")])], 1)], 1)])])])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 17
    }
  }, [_c('div', {
    staticClass: "form-wapper"
  }, [_c('a-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "change": _vm.callback
    }
  }, [_c('a-tab-pane', {
    key: "1",
    staticClass: "fm-class",
    attrs: {
      "tab": "封面"
    }
  }, [_c('div', {
    staticClass: "fm-boder-wapper"
  }, [_c('div', {
    staticClass: "fm-title",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "42px",
      "color": "#000",
      "font-weight": "900"
    }
  }, [_vm._v(" 绵阳中学英才学校 ")])]), _c('div', {
    staticClass: "fm-title"
  }, [_c('div', {
    staticStyle: {
      "font-size": "42px",
      "color": "#000",
      "font-weight": "900"
    }
  }, [_vm._v(" 校办会议案资 ")])]), _c('div', {
    staticClass: "fm-menu"
  }, [_c('div', {
    staticStyle: {
      "font-size": "30px",
      "color": "#000",
      "font-weight": "600"
    }
  }, [_vm._v(" 议题名称:" + _vm._s(_vm.formObject.title) + " ")])]), _c('div', {
    staticClass: "fm-menu"
  }, [_c('div', {
    staticStyle: {
      "font-size": "30px",
      "color": "#000",
      "font-weight": "600",
      "display": "flex"
    }
  }, [_vm._v(" 汇 "), _c('div', {
    staticStyle: {
      "margin": "0 15px"
    }
  }, [_vm._v("报")]), _vm._v(" 人:" + _vm._s(_vm.formObject.reportPerson) + " ")])]), _c('div', {
    staticClass: "fm-menu"
  }, [_c('div', {
    staticStyle: {
      "font-size": "30px",
      "color": "#000",
      "font-weight": "600"
    }
  }, [_vm._v(" 汇报部门:" + _vm._s(_vm.formObject.departmentCN.organIdName + '/' + _vm.formObject.departmentCN.postIdName) + " ")])])])]), _c('a-tab-pane', {
    key: "2",
    staticClass: "fm-class",
    attrs: {
      "tab": "上会资料提交表"
    }
  }, [_c('div', {
    staticClass: "fm2-boder-wapper1",
    staticStyle: {
      "width": "78%"
    }
  }, [_c('div', {
    staticClass: "fm-title",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "28px",
      "color": "#000",
      "font-weight": "900"
    }
  }, [_vm._v(" 绵阳中学英才学校 ")])]), _c('div', {
    staticClass: "fm-title"
  }, [_c('div', {
    staticStyle: {
      "font-size": "28px",
      "color": "#000",
      "font-weight": "900"
    }
  }, [_vm._v(" 上会资料提交清单 ")])]), _c('div', {
    staticClass: "fm2-menu1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#000",
      "width": "55%"
    }
  }, [_vm._v(" 会议组织部门: ")]), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#000",
      "width": "45%"
    }
  }, [_vm._v(" 呈报部门: ")])]), _c('div', {
    staticClass: "fm2-menu2"
  }, [_c('div', {
    staticClass: "fm2-menu-main"
  }, [_c('div', {
    staticClass: "fm2-menu-main1"
  }, [_vm._v("序号")]), _c('div', {
    staticClass: "fm2-menu-main2"
  }, [_vm._v("资料名称")]), _c('div', {
    staticClass: "fm2-menu-main3"
  }, [_vm._v(" 必备 "), _c('br'), _vm._v(" (可选) ")]), _c('div', {
    staticClass: "fm2-menu-main4"
  }, [_vm._v(" 会议组织 "), _c('br'), _vm._v(" 部门确认 ")]), _c('div', {
    staticClass: "fm2-menu-main4"
  }, [_vm._v(" 呈报部门 "), _c('br'), _vm._v(" 确认 ")]), _c('div', {
    staticClass: "fm2-menu-main5"
  }, [_vm._v("备注")])]), _c('div', {
    staticClass: "fm2-menu-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm2-menu-main1"
  }, [_vm._v("1")]), _c('div', {
    staticClass: "fm2-menu-main2"
  }, [_vm._v("封面")]), _c('div', {
    staticClass: "fm2-menu-main3"
  }, [_vm._v("必备")]), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main5"
  })]), _c('div', {
    staticClass: "fm2-menu-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm2-menu-main1"
  }, [_vm._v("2")]), _c('div', {
    staticClass: "fm2-menu-main2"
  }, [_vm._v(" 议题审批表/紧急上 "), _c('br'), _vm._v(" 会议题审批表 ")]), _c('div', {
    staticClass: "fm2-menu-main3"
  }, [_vm._v("必备")]), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main5"
  })]), _c('div', {
    staticClass: "fm2-menu-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm2-menu-main1"
  }, [_vm._v("3")]), _c('div', {
    staticClass: "fm2-menu-main2"
  }, [_vm._v("议案正文")]), _c('div', {
    staticClass: "fm2-menu-main3"
  }, [_vm._v("必备")]), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main5"
  })]), _c('div', {
    staticClass: "fm2-menu-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm2-menu-main1"
  }, [_vm._v("4")]), _c('div', {
    staticClass: "fm2-menu-main2"
  }, [_vm._v("补档文件")]), _c('div', {
    staticClass: "fm2-menu-main3"
  }, [_vm._v("可选")]), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main5"
  })]), _c('div', {
    staticClass: "fm2-menu-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm2-menu-main1"
  }, [_vm._v("5")]), _c('div', {
    staticClass: "fm2-menu-main2"
  }, [_vm._v("附件资料")]), _c('div', {
    staticClass: "fm2-menu-main3"
  }, [_vm._v("可选")]), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main5"
  })]), _c('div', {
    staticClass: "fm2-menu-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm2-menu-main1"
  }, [_vm._v("6")]), _c('div', {
    staticClass: "fm2-menu-main2"
  }, [_vm._v("法律意见书")]), _c('div', {
    staticClass: "fm2-menu-main3"
  }, [_vm._v("可选")]), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main5"
  })]), _c('div', {
    staticClass: "fm2-menu-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm2-menu-main1"
  }, [_vm._v("7")]), _c('div', {
    staticClass: "fm2-menu-main2"
  }, [_vm._v(" 风控法务部审查 "), _c('br'), _vm._v(" 意见书 ")]), _c('div', {
    staticClass: "fm2-menu-main3"
  }, [_vm._v("可选")]), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main5"
  })]), _c('div', {
    staticClass: "fm2-menu-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm2-menu-main1"
  }, [_vm._v("8")]), _c('div', {
    staticClass: "fm2-menu-main2"
  }, [_vm._v(" 相关部门审查 "), _c('br'), _vm._v(" 意见表 ")]), _c('div', {
    staticClass: "fm2-menu-main3"
  }, [_vm._v("可选")]), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main5"
  })]), _c('div', {
    staticClass: "fm2-menu-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm2-menu-main1"
  }, [_vm._v("9")]), _c('div', {
    staticClass: "fm2-menu-main2"
  }, [_vm._v("其他意见")]), _c('div', {
    staticClass: "fm2-menu-main3"
  }, [_vm._v("可选")]), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main5"
  })]), _c('div', {
    staticClass: "fm2-menu-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm2-menu-main1"
  }, [_vm._v("10")]), _c('div', {
    staticClass: "fm2-menu-main2"
  }, [_vm._v("材料真实性承诺书")]), _c('div', {
    staticClass: "fm2-menu-main3"
  }, [_vm._v("必备")]), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main4"
  }), _c('div', {
    staticClass: "fm2-menu-main5"
  })])]), _c('div', {
    staticClass: "fm2-menu1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#000",
      "width": "55%"
    }
  }, [_vm._v(" 会议组织部门接收人: ")]), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#000",
      "width": "45%"
    }
  }, [_vm._v(" 呈报部门提交人: ")])])])]), _c('a-tab-pane', {
    key: "3",
    staticClass: "fm-class",
    attrs: {
      "tab": "校长办公会议题审批表"
    }
  }, [_c('div', {
    staticClass: "fm-boder-wapper1",
    staticStyle: {
      "width": "78%"
    }
  }, [_c('div', {
    staticClass: "fm-title",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "28px",
      "color": "#000",
      "font-weight": "900"
    }
  }, [_vm._v(" 绵阳中学英才学校 ")])]), _c('div', {
    staticClass: "fm-title"
  }, [_c('div', {
    staticStyle: {
      "font-size": "28px",
      "color": "#000",
      "font-weight": "900"
    }
  }, [_vm._v(" 校长办公会议题审批表 ")])]), _c('div', {
    staticClass: "fm-menu1"
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#000"
    }
  }, [_vm._v("填报部门：")]), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#000"
    }
  }, [_vm._v("填报时间：")])]), _c('div', {
    staticClass: "fm-menu2"
  }, [_c('div', {
    staticClass: "fm-menu2-main"
  }, [_c('div', {
    staticClass: "fm-menu2-main-left"
  }, [_vm._v("议题名称")]), _c('div', {
    staticClass: "fm-menu2-main-right"
  }, [_vm._v(" " + _vm._s(_vm.formObject.title) + " ")])]), _c('div', {
    staticClass: "fm-menu2-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm-menu2-main-left"
  }, [_vm._v(" 提请审议 "), _c('br'), _vm._v(" 主要事项 ")]), _c('div', {
    staticClass: "fm-menu2-main-right"
  }, [_vm._v(" " + _vm._s(_vm.formObject.title) + " ")])]), _c('div', {
    staticClass: "fm-menu2-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm-menu2-main-left"
  }, [_vm._v("相关部门会签")]), _c('div', {
    staticClass: "fm-menu2-main-right"
  }, [_vm._v(" " + _vm._s(_vm.formObject.title) + " ")])]), _c('div', {
    staticClass: "fm-menu2-main",
    staticStyle: {
      "border-top": "0px",
      "min-height": "120px",
      "max-height": "auto"
    }
  }, [_c('div', {
    staticClass: "fm-menu2-main-left"
  }, [_vm._v(" 汇报人姓名 "), _c('br'), _vm._v(" 及职务 ")]), _c('div', {
    staticClass: "fm-menu2-main-left1"
  }, [_vm._v(" " + _vm._s(_vm.formObject.title) + " ")]), _c('div', {
    staticClass: "fm-menu2-main-left2"
  }, [_c('div', {
    staticClass: "fm-menu2-main-left2-top"
  }, [_c('div', {
    staticClass: "fm-menu2-main-left2-top-left"
  }, [_vm._v(" 受理日期 ")]), _c('div', {
    staticClass: "fm-menu2-main-left2-top-right"
  }, [_vm._v(" " + _vm._s(_vm.formObject.title) + " ")])]), _c('div', {
    staticClass: "fm-menu2-main-left2-bottom"
  }, [_c('div', {
    staticClass: "fm-menu2-main-left2-bottom-left"
  }, [_vm._v(" 最后补 "), _c('br'), _vm._v(" 档日期 ")]), _c('div', {
    staticClass: "fm-menu2-main-left2-bottom-right"
  }, [_vm._v(" " + _vm._s(_vm.formObject.title) + " ")])])]), _c('div', {
    staticClass: "fm-menu2-main-left3"
  }, [_c('div', {
    staticClass: "fm-menu2-main-left3-left"
  }, [_vm._v(" 上报 "), _c('br'), _vm._v(" 审批 "), _c('br'), _vm._v(" 日期 ")]), _c('div', {
    staticClass: "fm-menu2-main-left3-right"
  }, [_vm._v(" " + _vm._s(_vm.formObject.title) + " ")])]), _c('div')]), _c('div', {
    staticClass: "fm-menu2-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm-menu2-main-left"
  }, [_vm._v(" 需列席的 "), _c('br'), _vm._v(" 部门人员 ")]), _c('div', {
    staticClass: "fm-menu2-main-right"
  }, [_vm._v(" " + _vm._s(_vm.formObject.title) + " ")])]), _c('div', {
    staticClass: "fm-menu2-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm-menu2-main-left"
  }, [_vm._v(" 部门负责人 "), _c('br'), _vm._v(" 意见 ")]), _c('div', {
    staticClass: "fm-menu2-main-right"
  }, [_vm._v(" " + _vm._s(_vm.formObject.title) + " ")])]), _c('div', {
    staticClass: "fm-menu2-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm-menu2-main-left"
  }, [_vm._v(" 分管领导 "), _c('br'), _vm._v(" 意见 ")]), _c('div', {
    staticClass: "fm-menu2-main-right"
  }, [_vm._v(" " + _vm._s(_vm.formObject.title) + " ")])]), _c('div', {
    staticClass: "fm-menu2-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm-menu2-main-left"
  }, [_vm._v(" 行政办公室 "), _c('br'), _vm._v(" 负责人意见 ")]), _c('div', {
    staticClass: "fm-menu2-main-right"
  }, [_vm._v(" " + _vm._s(_vm.formObject.title) + " ")])]), _c('div', {
    staticClass: "fm-menu2-main",
    staticStyle: {
      "border-top": "0px"
    }
  }, [_c('div', {
    staticClass: "fm-menu2-main-left"
  }, [_vm._v(" 校长 "), _c('br'), _vm._v(" 意见 ")]), _c('div', {
    staticClass: "fm-menu2-main-right"
  }, [_vm._v(" " + _vm._s(_vm.formObject.title) + " ")])])])])]), _c('a-tab-pane', {
    key: "4",
    staticClass: "fm-class",
    attrs: {
      "tab": "材料真实性承诺书"
    }
  }, [_c('div', {
    staticClass: "fm-boder-wapper1"
  }, [_c('div', {
    staticClass: "fm-title",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "28px",
      "color": "#000",
      "font-weight": "900"
    }
  }, [_vm._v(" 绵阳中学英才学校 ")])]), _c('div', {
    staticClass: "fm-title"
  }, [_c('div', {
    staticStyle: {
      "font-size": "28px",
      "color": "#000",
      "font-weight": "900"
    }
  }, [_vm._v(" 材料真实性承诺书 ")])]), _c('div', {
    staticClass: "fm-main"
  }, [_c('div', {
    staticClass: "fm-main-menu1"
  }, [_vm._v("学校理事会/党委会/校办会：")]), _c('div', {
    staticClass: "fm-main-menu2"
  }, [_vm._v(" 我部门对报送给理事会/党委会/校办会的材料做出承诺，保 证报送材料真实、客观，无伪造、编造、变造、篡改和隐瞒等虚假内容，否则承担由此发生的一切后果。 ")]), _c('div', {
    staticClass: "fm-main-menu2"
  }, [_vm._v("特此承诺。")]), _c('div', {
    staticClass: "fm-main-menu",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('div', {
    staticClass: "fm-main-menu-left"
  }, [_vm._v("承诺部门：")]), _c('div', {
    staticClass: "fm-main-menu-right"
  })]), _c('div', {
    staticClass: "fm-main-menu"
  }, [_c('div', {
    staticClass: "fm-main-menu-left"
  }, [_vm._v("部门负责人：")]), _c('div', {
    staticClass: "fm-main-menu-right"
  })]), _c('div', {
    staticClass: "fm-main-menu"
  }, [_c('div', {
    staticClass: "fm-main-menu-left"
  }, [_vm._v("部门分管领导：")]), _c('div', {
    staticClass: "fm-main-menu-right"
  })]), _c('div', {
    staticClass: "fm-main-menu"
  }, [_c('div', {
    staticClass: "fm-main-menu-left"
  }, [_vm._v("日期：")]), _c('div', {
    staticClass: "fm-main-menu-right"
  })])])])])], 1)], 1)])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };